(function ($)
{
    let cStorySearchObjectCounter = 0;

    $.widget("ui.StorySearch",
        {
            _MyObjectNumber: null,

            options:
            {
                PageContentId: null,
                InitialPagerData: null,
                StoryResultSelector: '.story_list_result.story',
                ResultListSelector: '.story_list',
                StoryGallerySelector: '.story_search_results',
                LinkedStoryClass: 'fbcms_linkedstory'
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
                VideoUtilities.SetupVideoResizer('.storymedia_video');
            },

            _create: function ()
            {
                const self = this;
                const jElement = $(self.element);
                if (self.options.PageContentId === null)
                {
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LinkedStoryClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.StoryGallerySelector))
                {
                    FBUtilities.LogMessage('StoryList - required settings null or empty.');
                    return;
                }

                self._MyObjectNumber = cStorySearchObjectCounter++;

                const storySearchResultId = 'StorySearchResult' + self._MyObjectNumber;

                const jResultsContainer = jElement.find(self.options.ResultListSelector);
                jResultsContainer.attr('role', 'region');
                jResultsContainer.attr('aria-live', 'polite');
                jResultsContainer.attr('id', storySearchResultId);

                self.SetupStoryButtons();
                self.SetupPagination();

                const jSearchButton = jElement.find('.search_button');
                jSearchButton.on('click', function (aEvent) 
                {
                    aEvent.preventDefault();
                    self.Search();
                    return false;
                });
                jSearchButton.attr('aria-controls', storySearchResultId);

                const jResetButton = jElement.find('.reset_button');
                jResetButton.on('click', function (aEvent) 
                {
                    aEvent.preventDefault();
                    self.Reset();
                    return false;
                });
                jResetButton.attr('aria-controls', storySearchResultId);

                const jFilterSearchText = jElement.find('input[name="SearchText"]');
                jFilterSearchText.attr('aria-controls', storySearchResultId);
                jFilterSearchText.on(
                    'keypress',
                    function (aEvent)
                    {
                        if (aEvent.key === "Enter")
                        {
                            aEvent.preventDefault();
                            self.Search();
                            return false;
                        }
                        // nevermind, carry on...
                        return true;
                    }
                );

                const jFilterStartDate = jElement.find('input[name="SearchDateRangeStart"]');
                const jFilterEndDate = jElement.find('input[name="SearchDateRangeEnd"]');

                if (jFilterStartDate.length === 1
                    && jFilterEndDate.length === 1)
                {
                    const checkDatePickers = function (aStartModified)
                    {
                        const startText = jFilterStartDate.val();
                        const endText = jFilterEndDate.val();
                        if (startText.length !== 0
                            && endText.length !== 0)
                        {
                            const startDate = new Date(startText);
                            const endDate = new Date(endText);

                            if (startDate > endDate)
                            {
                                if (aStartModified === true)
                                {
                                    jFilterEndDate.val(startText);
                                }
                                else
                                {
                                    jFilterStartDate.val(endText);
                                }
                            }
                        }
                    };

                    //lFilterStartDate.FBDateSelector({
                    //        ClearInputButtonLabel: 'Clear Start Date'
                    //        ,OnChangeCallback: function (aEvent) { lCheckDatePickers(true); }
                    //});

                    //lFilterEndDate.FBDateSelector({
                    //        ClearInputButtonLabel: 'Clear End Date'
                    //        ,OnChangeCallback: function (aEvent) { lCheckDatePickers(false); }
                    //});

                    jFilterStartDate.attr('aria-controls', storySearchResultId);
                    jFilterEndDate.attr('aria-controls', storySearchResultId);

                    jFilterStartDate.on(
                        'keypress',
                        function (aEvent)
                        {
                            if (aEvent.key === "Enter")
                            {
                                aEvent.preventDefault();
                                self.Search();
                                return false;
                            }
                            // nevermind, carry on...
                            return true;
                        }
                    );
                    jFilterEndDate.on(
                        'keypress',
                        function (aEvent)
                        {
                            if (aEvent.key === "Enter")
                            {
                                aEvent.preventDefault();
                                self.Search();
                                return false;
                            }
                            // nevermind, carry on...
                            return true;
                        }
                    );
                }

                $.each(
                    jElement.find('.category'),
                    function (aIndex, aValue)
                    {
                        $(aValue).TagCategorySearchFilter(
                            {
                                CategoryNameSelector: '.category_topper'
                                , ItemContainerSelector: '.items'
                                , FilterControlsElementId: storySearchResultId
                            });
                    }
                );

                //self.Reset();
            },

            Reset: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.story_search_form');

                // reset all input fields.
            jFormDiv.find('input[name="SearchText"]').val('');
            jFormDiv.find('input[name="SearchDateRangeStart"]').val('');
            jFormDiv.find('input[name="SearchDateRangeEnd"]').val('');
                $.each(
                    jElement.find('.category'),
                    function (aIndex, aValue)
                    {
                        $(aValue).TagCategorySearchFilter('Reset');
                    }
                );

            jElement.find('.story_search_form').find('input[name="IsReset"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            GetSearchData: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.story_search_form');

                const searchData = {
                    "PageContentId": self.options.PageContentId,
                "FromStorySearchForm": jFormDiv.find('input[name="IsNewSearch"]').val(),
                "ResetStorySearchForm": jFormDiv.find('input[name="IsReset"]').val(),
                "SearchText": jFormDiv.find('input[name="SearchText"]').val(),
                "SearchDateRangeStart": jFormDiv.find('input[name="SearchDateRangeStart"]').val(),
                "SearchDateRangeEnd": jFormDiv.find('input[name="SearchDateRangeEnd"]').val(),
                    "SelectedItems": jFormDiv.find('input[name=SelectedItems]:checked')
                        .map(function () {return $(this).val();})
                        .get().join(',')
                };

            jFormDiv.find('input[name="IsNewSearch"]').val('');
            jFormDiv.find('input[name="IsReset"]').val('');

                return searchData;
            },

            Search: function ()
            {
                const self = this;
                const jElement = $(self.element);

            jElement.find('.story_search_form').find('input[name="IsNewSearch"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            SetupPagination: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const storySearchResultId = 'StorySearchResult' + self._MyObjectNumber;
                const jNormalContainer = jElement.find(self.options.StoryGallerySelector);
                const jMoreContainer = jNormalContainer.find(self.options.ResultListSelector);

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/Stories/Search/${self.options.PageContentId}/`,
                        LoadingTitle: "Story Search",
                        NormalContainer: jNormalContainer,
                        MoreContainer: jMoreContainer,
                        OnSuccess: function (mode, data, textStatus, jqXHR)
                        {
                            self.SetupStoryButtons();
                        },
                        InitialPagerData: self.options.InitialPagerData,
                        RequestDataFunc: function ()
                        {
                            return self.GetSearchData();
                        },
                        LiveRegionId: storySearchResultId
                    });
            },

            SetupStoryButtons: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jGallery = jElement.find(self.options.StoryGallerySelector);
                const jContainer = jElement.find(self.options.ResultListSelector);
                const jStories = jContainer.find(self.options.StoryResultSelector);
                const jControlledStoryBlock = $('.fbcms_story_block');

                $.each(
                    jStories,
                    function (aIndex, aValue)
                    {
                        const jStory = $(aValue);
                        const jLinkElement = jStory.find('[data-story-id]');
                        if (jStory.hasClass('story_link') === false)
                        {
                            return;
                        }
                        if (jStory.hasClass(self.options.LinkedStoryClass))
                        {
                            return;
                        }
                        jStory.addClass(self.options.LinkedStoryClass);
                        const url = jLinkElement.data('href');
                        if (FBUtilities.IsParameterUndefinedOrNull(url))
                        {
                            if (jControlledStoryBlock.length > 0)
                            {
                                jLinkElement.attr('aria-controls', jControlledStoryBlock.attr('id'));
                            }
                        }
                    }
                );

                jGallery.on(
                    'click keydown',
                    self.options.StoryResultSelector,
                    function (aEvent)
                    {
                        if (aEvent.type === "keydown"
                            && aEvent.key !== "Enter")
                        {
                            return true;
                        }

                        aEvent.preventDefault();
                        const jTarget = $(aEvent.target);
                        const jStory = jTarget.parents(self.options.StoryResultSelector);
                        if (jStory.hasClass('story_link') === false)
                        {
                            return false;
                        }
                        const jLinkElement = jStory.find('[data-story-id]');
                        const storyId = jLinkElement.data('story-id');
                        if (FBUtilities.IsParameterUndefinedOrEmpty(storyId))
                        {
                            return false;
                        }

                        const url = jLinkElement.data('href');
                        if (FBUtilities.IsParameterUndefinedOrEmpty(url))
                        {
                            if (jControlledStoryBlock.length > 0)
                            {
                                jControlledStoryBlock.StoryBlock(
                                    'LoadStory',
                                    storyId,
                                    {
                                        OnComplete: function () 
                                        {
                                            $(window).scrollTop(jControlledStoryBlock.offset().top);
                                            jControlledStoryBlock.focus();
                                        }
                                    },
                                    2000 /* transition speed */);
                            }
                        }
                        else if (jLinkElement.data('target-new'))
                        {
                            window.open(url, "_blank");
                        }
                        else
                        {
                            window.location = url;
                        }
                        return false;
                    }
                );
            }

        });
})(jQuery);
